














import { Vue, Component } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
@Component
export default class Header extends Vue {
  get greetingName() {
  return vxm.users.myUserProfile.preferredName ? vxm.users.myUserProfile.preferredName : vxm.users.myUserProfile.firstName;
  }
  get brandLogo() {
    return vxm.jobs.getCompanyLogoUrl();
  }
}
